import { useConsent } from './useConsent';

export const useConsentReady: () => boolean = () => {
  const { isConsentReady } = useConsent();
  return isConsentReady;
};
